export default [{ label: 'Abbey Road Institute', value: 'EmailTemplate1' }]
